import { render, staticRenderFns } from "./deliveryRequests.vue?vue&type=template&id=e87bf1da&"
import script from "./deliveryRequests.vue?vue&type=script&lang=js&"
export * from "./deliveryRequests.vue?vue&type=script&lang=js&"
import style0 from "./deliveryRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports